import * as api from "../../../shared/lib/api";
import { extractApiErrorMessage } from "../../../shared/utils/extract-api-error-message";
import type {
	ApiParameterBindingProps,
	ApiSourcePathsProps,
	CreateApiParameterBindingPayload,
	ListApiParameterBindingProps,
} from "../types/product";

const BASE_URL = "product/api-parameter-binding";

type SourcePathsResult =
	| { ok: true; hasSample: boolean; paths: string[] }
	| { ok: false; message: string };

type CreateBindingResult =
	| { ok: true; binding: ApiParameterBindingProps }
	| { ok: false; message: string };

export async function listBindings(
	productId: string,
): Promise<ApiParameterBindingProps[]> {
	const response = await api.get<ListApiParameterBindingProps>(
		`${BASE_URL}/list/${productId}/`,
	);
	return Array.isArray(response?.content) ? response.content : [];
}

export async function getSourcePaths(
	apiId: string,
): Promise<SourcePathsResult> {
	const response = await api.get<ApiSourcePathsProps>(
		`${BASE_URL}/source-paths/${apiId}/`,
	);

	if (Array.isArray(response?.content?.paths)) {
		return {
			ok: true,
			hasSample: response.content.has_sample,
			paths: response.content.paths,
		};
	}

	return {
		ok: false,
		message: extractApiErrorMessage({ data: response }) ?? "",
	};
}

export async function createBinding(
	payload: CreateApiParameterBindingPayload,
): Promise<CreateBindingResult> {
	const response = await api.post(`${BASE_URL}/create/`, payload);

	if (response?.status === 201) {
		return { ok: true, binding: response.data.content };
	}

	return { ok: false, message: extractApiErrorMessage(response) ?? "" };
}

export async function removeBinding(bindingId: string): Promise<boolean> {
	const response = await api.destroy(`${BASE_URL}/destroy/${bindingId}/`);
	return response?.status === 204;
}
